import { IconProps } from './IconProps';

import IconSvg from '../../components/svg-icon/IconSvg';

export const DownloadIcon2 = (props: IconProps) => {
  return (
    <IconSvg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"></path>
    </IconSvg>
  );
};
